import { css } from '@emotion/css';
import { subdoc } from 'Common/ViewUtils';
import { useStore } from 'Shared/StoreProvider';
import { theme } from 'Shared/ThemeProvider';
import { Show } from 'solid-js';


/*
	An anchor inside an anchor is invalid HTML: the browser un-nests them, which breaks hydration of
	the whole section. The frontend drops the inner link rather than emit one (cf InsideLinkContext),
	so tell the editor that this component won't be clickable in its own right.
*/
export function NestedLinkWarning()
{
	const sw = useStore();

	const warningStyle = css(theme().warning);

	return (
		<Show when={insideLinkBlock(sw.store,sw.location)}>
			<div class={warningStyle}>
				This sits inside another link block. This link will be ignored.
			</div>
		</Show>
	);
}


function insideLinkBlock(store,location): boolean
{
	for (let depth = location.length-1; depth >= 1; depth--) {
		const node = subdoc(store,location.slice(0,depth)) as {layout?:string,isAnchor?:boolean};
		if (node?.layout == 'link' && !node.isAnchor)
			return true;
	}
	return false;
}
